// import React, { useState, useEffect } from "react";
// import { Row, Col, Card, Statistic, Tabs, Typography, Button, Popconfirm } from "antd";

// import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
// import { DeleteOutlined } from "@ant-design/icons";

// import DashboardCharts from "./Usercomp/DashboardChart";

// import {
//   useGetAllStrategyQuery,
//   useAssignStrategyMetricsQuery,
//   useGetStrategyMetricsQuery,
//   useDeleteStrategyMutation,
// } from "../slices/strategyApiSlice";
// import InsightsCard from "./Usercomp/insightChart";

// const { Title } = Typography;

// const Dashboard = () => {
//   // get strategies
//   const { data: strategies } = useGetAllStrategyQuery();
// const [deleteStrategy] = useDeleteStrategyMutation();
//   const strategyList = strategies?.data || [];

//   // selected strategy
//   const [selectedStrategy, setSelectedStrategy] = useState(null);

//   // 👇 automatically fetch metrics when strategy changes
//   const { data: metrics } = useGetStrategyMetricsQuery(selectedStrategy, {
//     skip: !selectedStrategy,
//   });

//   useEffect(() => {
//     if (strategyList.length && !selectedStrategy) {
//       setSelectedStrategy(strategyList[0].id);
//     }
//   }, [strategyList]);

//   const handleStrategyChange = (key) => {
//     setSelectedStrategy(key);
//   };
//   // // mutation to fetch metrics



// const handleDelete = async () => {
//   if (!selectedStrategy) return;

//   await deleteStrategy({ id: selectedStrategy });

//   const remaining = strategyList.filter(
//     (s) => s.id !== selectedStrategy
//   );
//   setSelectedStrategy(remaining[0]?.id || null);
// };


//   return (
//     <div>
//       {/* <Title level={2}>Strategy Dashboard</Title> */}
//       <Row justify="space-between" align="middle">
//   <Col>
//     <Title level={2}>Strategy Dashboard</Title>
//   </Col>

//   <Col>
//     <Popconfirm
//       title="Delete this strategy?"
//       onConfirm={handleDelete}
//       okText="Yes"
//       cancelText="No"
//     >
//       <Button danger icon={<DeleteOutlined />}>
//         Delete Strategy
//       </Button>
//     </Popconfirm>
//   </Col>
// </Row>

//       {/* Strategy Tabs */}
//       <Tabs
//         activeKey={selectedStrategy}
//         onChange={handleStrategyChange}
//         items={strategyList.map((s) => ({
//           key: s.id,
//           label: s.name,
//         }))}
//       />

//       {/* Stats Row */}
//       <Row gutter={[16, 24]} style={{ marginBottom: "10px" }}>
//         <Col md={6} xs={24}>
//           <Card>
//             <Statistic
//               title="Realised (P&L)"
//               value={metrics?.total_profit || 0}
//               precision={2}
//               valueStyle={{
//                 color: metrics?.total_profit > 0 ? "#e9c46a" : "#8e9196",
//               }}
//               prefix={
//                 metrics?.total_profit > 0 ? (
//                   <ArrowUpOutlined />
//                 ) : (
//                   <ArrowDownOutlined />
//                 )
//               }
//               suffix="₹"
//             />
//           </Card>
//         </Col>

//         <Col md={6} xs={24}>
//           <Card>
//             <Statistic
//               title="Trade Win %"
//               value={metrics?.win_rate || 0}
//               suffix="%"
//               valueStyle={{ color: "#2980b9" }}
//             />
//           </Card>
//         </Col>

//         <Col md={6} xs={24}>
//           <Card>
//             <Statistic
//               title="Profit Factor"
//               value={metrics?.profit_factor || 0}
//               precision={2}
//               valueStyle={{ color: "#2980b9" }}
//             />
//           </Card>
//         </Col>

//         <Col md={6} xs={24}>
//           <Card>
//             <Statistic
//               title="Total Trades"
//               value={metrics?.total_trades || 0}
//               valueStyle={{ color: "#2980b9" }}
//             />
//           </Card>
//         </Col>
//       </Row>

//       {/* Charts */}
//       <Row gutter={[16, 24]}>
//         <DashboardCharts data={metrics}  />
        
//       </Row>
//     </div>
//   );
// };

// export default Dashboard;

import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Statistic,
  Tabs,
  Typography,
  Button,
  Popconfirm,
} from "antd";

import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import DashboardCharts from "./Usercomp/DashboardChart";
import InsightsCard from "./Usercomp/insightChart";
import "./css/strategy.css";
import {
  useGetAllStrategyQuery,
  useGetStrategyMetricsQuery,
  useDeleteStrategyMutation,
} from "../slices/strategyApiSlice";

// Import glass.css using the correct relative path.
// Adjust this path to match your project structure.

const { Title } = Typography;

const Dashboard = () => {
  const { data: strategies } = useGetAllStrategyQuery();
  const [deleteStrategy] = useDeleteStrategyMutation();

  const strategyList = strategies?.data || [];
  const [selectedStrategy, setSelectedStrategy] = useState(null);

  const { data: metrics } = useGetStrategyMetricsQuery(selectedStrategy, {
    skip: !selectedStrategy,
  });

  useEffect(() => {
    if (strategyList.length && !selectedStrategy) {
      setSelectedStrategy(strategyList[0].id);
    }
  }, [strategyList, selectedStrategy]);

  const handleStrategyChange = (key) => {
    setSelectedStrategy(key);
  };

  const handleDelete = async () => {
    if (!selectedStrategy) return;

    try {
      await deleteStrategy({ id: selectedStrategy }).unwrap();

      const remaining = strategyList.filter(
        (strategy) => strategy.id !== selectedStrategy
      );

      setSelectedStrategy(remaining[0]?.id || null);
    } catch (error) {
      console.error("Failed to delete strategy:", error);
    }
  };

  const profit = Number(metrics?.total_profit ?? 0);
  const GOLD = "#e9c46a";
const GREY = "#8e9196";

const winRate = Number(metrics?.win_rate ?? 0);
const profitFactor = Number(metrics?.profit_factor ?? 0);

const pnlColor = profit > 0 ? GOLD : GREY;
const winRateColor = winRate >= 50 ? GOLD : GREY;
const factorColor = profitFactor > 1 ? GOLD : GREY;

  return (
    <div className="glass-scope strategy-dashboard">
      {/* Dashboard Header */}
      <Row
        justify="space-between"
        align="middle"
        gutter={[16, 16]}
        className="strategy-dashboard-header"
      >
        <Col>
          <Title level={2} className="strategy-dashboard-title">
            Strategy Dashboard
          </Title>
          <div className="strategy-dashboard-subtitle">
            Track your trading performance
          </div>
        </Col>

        <Col>
          <Popconfirm
            title="Delete this strategy?"
            description="This action cannot be undone."
            onConfirm={handleDelete}
            okText="Yes, Delete"
            cancelText="Cancel"
            disabled={!selectedStrategy}
          >
            <Button
              className="glass-delete-button"
              icon={<DeleteOutlined />}
              disabled={!selectedStrategy}
            >
              Delete Strategy
            </Button>
          </Popconfirm>
        </Col>
      </Row>

      {/* Strategy Tabs */}
      <div className="strategy-tabs-glass">
        <Tabs
          activeKey={selectedStrategy || undefined}
          onChange={handleStrategyChange}
          items={strategyList.map((strategy) => ({
            key: strategy.id,
            label: strategy.name,
          }))}
        />
      </div>
{/* Statistics */}
<Row gutter={[16, 16]} className="strategy-stats-row">
  <Col xs={24} sm={12} lg={6}>
       <Card className={`strategy-stat-card ${pnlColor === GOLD ? "stat-win" : "stat-loss"}`} bordered={false}>      <Statistic
        title="Realised (P&L)"
        value={profit}
        precision={2}
        valueStyle={{ color: pnlColor, fontWeight: 700 }}
        prefix="₹"
      />
    </Card>
  </Col>

  <Col xs={24} sm={12} lg={6}>
       <Card className={`strategy-stat-card ${winRateColor === GOLD ? "stat-win" : "stat-loss"}`} bordered={false}>      <Statistic
        title="Trade Win %"
        value={winRate}
        precision={2}
        suffix="%"
        valueStyle={{ color: winRateColor, fontWeight: 700 }}
      />
    </Card>
  </Col>

  <Col xs={24} sm={12} lg={6}>
<Card className={`strategy-stat-card ${factorColor === GOLD ? "stat-win" : "stat-loss"}`} bordered={false}>      <Statistic
        title="Profit Factor"
        value={profitFactor}
        precision={2}
        valueStyle={{ color: factorColor, fontWeight: 700 }}
      />
    </Card>
  </Col>

  <Col xs={24} sm={12} lg={6}>
    <Card className="strategy-stat-card" bordered={false}>
      <Statistic
        title="Total Trades"
        value={Number(metrics?.total_trades ?? 0)}
        valueStyle={{ color: "#ffffff", fontWeight: 700 }}
      />
    </Card>
  </Col>
</Row>

      {/* Charts */}
      <Row gutter={[16, 24]} className="strategy-charts-row">
        <DashboardCharts data={metrics} />
      </Row>

      {/* Keep this section if InsightsCard is needed on this dashboard */}
      {/* <InsightsCard data={metrics} /> */}
    </div>
  );
};

export default Dashboard;